module.exports = __webpack_public_path__ + "static/media/dane-flag.623ea18d.svg";